import { makeAutoObservable } from 'mobx';
import i18n from 'src/i18n';
import createStoreContext from '../createStoreContext';

export const AVAILABLE_LANGUAGES = [
  // Primary set
  'gu', // Gujarati
  'es', // Spanish
  'it', // Italian
  'de', // German
  'te', // Telugu
  'ta', // Tamil
  'mr', // Marathi
  'ur', // Urdu
  'hi', // Hindi
  'ar', // Arabic
  'fa', // Persian
  'ru', // Russian
  'ko', // Korean
  'vi', // Vietnamese
  'zh', // Chinese
  'ja', // Japanese
  'tr', // Turkish
  'pt', // Portuguese
  'fr', // French
  'en', // English
  'nl', // Dutch
  'th', // Thai
  'id', // Indonesian
  // Also supported
  'da', // Danish
  'fi', // Finnish
  'he', // Hebrew
  'sv', // Swedish
  'pl', // Polish
] as const;

export const [LanguageProvider, useLanguageStore] = createStoreContext(
  class LanguageStore {
    language = i18n.language || 'en';

    constructor() {
      makeAutoObservable(this);
    }

    fetchLanguage = async (language: string | undefined): Promise<void> => {
      if (language) {
        this.language = language.toLowerCase();
      } else {
        this.language = language?.toLowerCase() || 'en';
      }

      await i18n.changeLanguage(this.language);
    };

    setLanguage = (lang: string) => {
      this.language = lang.toLowerCase();
      void i18n.changeLanguage(lang.toLowerCase());
    };
  },
);

export type LanguageStore = ReturnType<typeof useLanguageStore>;
